import { render, staticRenderFns } from "./AppointOrderInfo.vue?vue&type=template&id=541a50e0&scoped=true&"
import script from "./AppointOrderInfo.vue?vue&type=script&lang=js&"
export * from "./AppointOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppointOrderInfo.vue?vue&type=style&index=0&id=541a50e0&lang=less&scoped=true&"
import style1 from "./AppointOrderInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541a50e0",
  null
  
)

export default component.exports